module.exports = require("@carvana/icons/Close");